const en_master_bankaccount = {
    "": "bank account",
    bank: "bank",
    norek: "account number",
    namerek: "account name",
    add: "add bank account",
    edit: "edit bank account",

    error: {
        bank: "Bank cannot be empty.",
        norek: "Account number cannot be empty.",
        namerek: "Account name cannot be empty.",
        create: "Failed to create account.",
        delete: "Failed to delete account.",
        edit: "Failed to update account.",
    },

    success: {
        create: "Account created successfully.",
        delete: "Account deleted successfully.",
        edit: "Account updated successfully.",
    }
}

export default en_master_bankaccount;